<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <v-tabs v-model="tab">
          <v-tab id="paper-submit-tab">Paper</v-tab>
          <v-tab id="paper-revision-tab">Revision</v-tab>
          <v-tab id="paper-history-tab">History</v-tab>
        </v-tabs>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-tabs-items v-model="tab">
      <v-tab-item class="pa-3">
        <v-row justify="center" class="mb-3">
          <v-col cols="12" lg="10" md="10" sm="12" xs="12">
            <v-overlay :value="loading">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>

            <paperContentForm
              @updateFile="setFile"
              :paper="paper"
              ref="paperContent"
            />

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  id="paper-submit-button"
                  bottom
                  right
                  fixed
                  v-on="on"
                  @click="edit ? updatePaper() : createPaper()"
                  color="#FBBD21"
                  dark
                  fab
                >
                  <v-icon>{{ icon.mdiContentSave }}</v-icon>
                </v-btn>
              </template>

              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="pa-3">
        <Comments :paper="paper" />
      </v-tab-item>
      <v-tab-item class="pa-3">
        <paper-history :paper="paper" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import PaperContentForm from "@/components/molecules/paper/PaperContentForm.vue";
import Comments from "@/components/atoms/paper/[PAPER]Comments.vue";
import { mdiContentSave } from "@mdi/js";
import paper from "@/helpers/paperStatus.js";
import PaperHistory from "@/components/atoms/paper/[PAPER]History.vue";

export default {
  components: {
    PaperContentForm,
    Comments,
    PaperHistory,
  },
  data: () => ({
    icon: {
      mdiContentSave,
    },
    tab: 0,
    edit: false,
    paper: {
      title: "",
      abstract: "",
      keywords: [],
      trackId: "",
      lastUpdate: "",
      authors: [
        {
          name: "",
          email: "",
          country: "",
          orcid: "",
        },
      ],
      state: {
        status: "Unassigned",
        reviews: {},
      },
      logs: [],
    },
    file: null,
    loading: false,
  }),
  methods: {
    createPaper() {
      this.$refs.paperContent.save();
    },
    async updatePaper() {
      this.loading = true;
      let succsesful = false;
      let updatedPaper = this.paper;
      let id = updatedPaper.id;
      let file = this.$refs.paperContent.file; //get file from child

      delete updatedPaper.id; //remove id from object
      updatedPaper.lastUpdate = new Date().toLocaleString("en-US"); //update last update

      await this.$store
        .dispatch("updatePaper", {
          id: id,
          data: updatedPaper,
        })
        .then(async () => {
          if (file)
            await this.$store
              .dispatch("updatePaperPdf", {
                file: file,
                name: id,
              })
              .then(() => {
                succsesful = true;
              });
          else succsesful = true;
        });
      this.loading = false;
      this.$router.push("/dashboard/researcher").then(() => {
        if (succsesful) {
          this.$store.dispatch("updateChangeLogs", {
            paperId: id,
            log: {
              label: `${paper.changeLog("", "")["reuploaded"].label}`,
              datetime: new Date().toLocaleString("en-US"),
            },
          }),
            this.$store.dispatch("setSnackbar", {
              show: true,
              text: "Success on updating paper!",
              color: "success",
            });
        } else {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Oops... Error on update Paper",
            color: "error",
          });
        }
      });
    },
    setFile(newFile) {
      this.file = newFile;
    },
  },
  async created() {
    var id = this.$route.params.paperId;

    if (id) {
      //is editting paper
      this.edit = true;

      if (!this.$store.getters.papers) await this.$store.dispatch("getPapers");
      this.paper = Object.assign({}, this.$store.getters.paperById(id));
    } else {
      this.edit = false;
    }
  },
};
</script>